import React, { useRef, useState } from "react";
import ChatHeader from "./ChatHeader";
import AvatarMenu from "./AvatarMenu";
import FirstOpen from "./FirstOpen";
import MessageList from "./MessageList";
import Composer from "./Composer";
import { getMood } from "./moodOpeners";
import { isGreeting } from "./copy";
import useKeyboardFit from "../ui/useKeyboardFit";
import "../ui/tokens.css";
import GuestNudge from "../guest/GuestNudge";
import "./chat.css";

// The student's chat screen: header, conversation (or the first-open welcome), composer and footer.
export default function ChatScreen({
  darkMode,
  isGuest,
  guestSecondsLeft,
  userName,
  userFirstName,
  avatarUrl,
  messages,
  isTyping,
  input,
  onInputChange,
  onSend,
  onLocalExchange,
  onOpenHistory,
  onNewChat,
  onOpenTasks,
  onOpenProfile,
  onClearChat,
  onLogout,
  onCreateAccount,
  onToggleDark,
  onOpenLockIn,
  onOpenTerms,
  scrollRef,
  attachments,
  fileInputRef,
  onFileChange,
  onToggleUpload,
  fileIcon,
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const rootRef = useRef(null);
  useKeyboardFit(rootRef);
  const fresh = !messages.some((m) => m.sender === "user");
  // The welcome is already on screen before the first message, so it is not repeated as a bubble.
  const shown = messages[0]?.sender === "bot" && isGreeting(messages[0].text) ? messages.slice(1) : messages;

  const handleMood = (id) => {
    const mood = getMood(id);
    if (mood) onLocalExchange(mood.label, mood.opener, mood.chips);
  };

  return (
    <div ref={rootRef} className="rg-chat">
      <ChatHeader
        userName={userName}
        avatarUrl={avatarUrl}
        isGuest={isGuest}
        guestSecondsLeft={guestSecondsLeft}
        menuOpen={menuOpen}
        onOpenHistory={onOpenHistory}
        onOpenMenu={() => setMenuOpen(true)}
      />

      <div className="rg-scroll" ref={scrollRef}>
        <div className="rg-col">
          {fresh ? (
            <FirstOpen firstName={isGuest ? "" : userFirstName} onMood={handleMood} onStarter={(text) => onSend(text)} />
          ) : (
            <MessageList
              messages={shown}
              isTyping={isTyping}
              scrollRef={scrollRef}
              onPickChip={(text) => onSend(text)}
              fileIcon={fileIcon}
            />
          )}
        </div>
      </div>

      <div className="rg-dock">
        <div className="rg-col">
          {attachments}
          <Composer
            value={input}
            onChange={onInputChange}
            onSend={() => onSend()}
            onToggleUpload={onToggleUpload}
            fileInputRef={fileInputRef}
            onFileChange={onFileChange}
          />
          <p className="rg-footer">
            Rigby is not a therapist. Crisis? Call or text <a href="tel:988">988</a>.{" "}
            <button type="button" className="rg-link" onClick={onOpenTerms}>
              Terms
            </button>
          </p>
        </div>
      </div>

      {isGuest ? <GuestNudge secondsLeft={guestSecondsLeft} onCreateAccount={onCreateAccount} /> : null}

      <AvatarMenu
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        userName={userName}
        isGuest={isGuest}
        darkMode={darkMode}
        onToggleDark={onToggleDark}
        onNewChat={onNewChat}
        onOpenTasks={onOpenTasks}
        onOpenLockIn={onOpenLockIn}
        onOpenProfile={onOpenProfile}
        onClearChat={onClearChat}
        onLogout={onLogout}
        onCreateAccount={onCreateAccount}
      />
    </div>
  );
}
